import React from "react";
import { Switch, Route } from "react-router-dom";
import UsersList from "./UsersList";
import Playlists from "./Playlists";
import Albums from "./Albums";
import Album from "./Album";
import { indexUserFollowers, indexUserFollowings } from "../../../../api/users";
import Playlist from "./Playlist";
import Podcasts from "./Podcasts";
import About from "./About";
import { isSelfId } from "../../../../api/helper";
import Activity from "./Activity";
import Singles from "./Singles";

export default ({ user }) => {
  const tweetBox =
    isSelfId(user.id) &&
    (user.user_type === "artist" || user.user_type === "podcaster");
  const tabs = {
    followings: (props) => (
      <UsersList
        {...props}
        type="followings"
        displayMessage={isSelfId(user.id)}
        index_func={(page_number, page_size) =>
          indexUserFollowings({ page_number, page_size, user_id: user.id })
        }
      />
    ),
    followers: (props) => (
      <UsersList
        {...props}
        type="followers"
        displayMessage={isSelfId(user.id)}
        index_func={(page_number, page_size) =>
          indexUserFollowers({ page_number, page_size, user_id: user.id })
        }
      />
    ),
    about: (props) => <About {...props} user={user} />,
    playlists: (props) => <Playlists {...props} user={user} />,
    playlist: (props) => <Playlist {...props} user={user} />,
    albums: (props) => <Albums {...props} user={user} />,
    album: (props) => <Album {...props} user={user} />,
    soundtracks: (props) => <Singles {...props} user={user} />,
    podcasts: (props) => <Podcasts {...props} user={user} />,
    activity: (props) => <Activity {...props} user={user} />,
  };
  return (
    <div className="flex-grow-1">
      <Switch>
        <Route path="/:username" exact render={tabs.activity} />
        <Route path="/:username/followings" exact render={tabs.followings} />
        <Route path="/:username/followers" exact render={tabs.followers} />
        <Route path="/:username/playlists" exact render={tabs.playlists} />
        <Route path="/:username/podcasts" exact render={tabs.podcasts} />
        <Route path="/:username/albums" exact render={tabs.albums} />
        <Route path="/:username/singles" exact render={tabs.soundtracks} />
        <Route path="/:username/about" exact render={tabs.about} />
        <Route
          path="/:username/playlists/:playlist_id"
          exact
          render={tabs.playlist}
        />
        <Route
          path="/:username/podcasts/:playlist_id"
          exact
          render={tabs.playlist}
        />
        <Route path="/:username/albums/:album_id" exact render={tabs.album} />
      </Switch>
    </div>
  );
};
